import { borderFill } from "../helpers";
import { ComponentF, ComponentO, createElement } from "../ui";
import { Container } from "./Container";

let id = 0;
let modals: { id: number; content: ComponentO }[] = [];

export const openModal = (content: ComponentO) => {
  const used = id;
  id += 1;
  modals.push({ id: used, content });
  return used;
};

export const closeModal = (id?: number) => {
  if (id != null) {
    modals = modals.filter((m) => m.id !== id);
  } else {
    modals.pop();
  }
};

const ModalContents: ComponentF<{ content: ComponentO }> = (C, { content }) => {
  borderFill(C.display, C.bounds);
  return [
    createElement(
      Container,
      {
        x: 1,
        y: 1,
        w: C.bounds.w - 2,
        h: C.bounds.h - 2,
      },
      { children: [content] }
    ),
  ];
};

export const Modal: ComponentF<null> = (C) => {
  return modals.map(({ content }) => {
    const width = content.bounds.w;
    const height = content.bounds.h;
    const b = {
      x: C.bounds.x + Math.floor((C.bounds.w - (content.bounds.w + 2)) / 2),
      y: C.bounds.y + Math.floor((C.bounds.h - (content.bounds.h + 2)) / 2),
      w: width + 2,
      h: height + 2,
    };
    return createElement(ModalContents, b, { content });
  });
};
